export default "__VITE_ASSET__BcWZKmNH__"